export const ToyCubes = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="12"
          y="12"
          width="9.00375"
          height="9.00375"
          rx="2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="2.99622"
          y="12"
          width="9.00375"
          height="9.00375"
          rx="2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="7.49817"
          y="2.99622"
          width="9.00375"
          height="9.00375"
          rx="2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="6.24756"
          y="15.2513"
          width="2.50104"
          height="2.50104"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="15.0432"
          y="15.0432"
          width="2.91822"
          height="2.91822"
          rx="1.458"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.2311 7.49817L11.9996 5.72967L13.7681 7.49817L11.9996 9.26667L10.2311 7.49817Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Toys cubes</div>
    </div>
  );
};

export const BookFairyTale = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.1713 14.5741C15.2488 14.5419 15.3378 14.5568 15.4006 14.6123C15.4634 14.6679 15.489 14.7544 15.4665 14.8352C15.3058 15.4589 14.9811 16.0282 14.5261 16.4839C13.644 17.4057 12.3321 17.7779 11.0973 17.4567C9.86259 17.1356 8.89834 16.1713 8.57717 14.9366C8.256 13.7018 8.62822 12.3899 9.54999 11.5078C10.0052 11.0524 10.5742 10.7273 11.1977 10.5664C11.2786 10.5431 11.3657 10.5684 11.4215 10.6314C11.4773 10.6945 11.4918 10.7841 11.4588 10.8616C10.9202 11.927 11.1268 13.2178 11.9709 14.062C12.8151 14.9061 14.1059 15.1127 15.1713 14.5741V14.5741Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="3.9967"
          y="6.99792"
          width="16.0067"
          height="14.0058"
          rx="3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.9967 9.99918V8.08938C3.99649 6.84074 4.76941 5.7224 5.93751 5.28121L14.294 2.1259C14.9086 1.89366 15.598 1.97791 16.1385 2.35132C16.679 2.72473 17.0018 3.3397 17.0021 3.99668V6.99793"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Book fairy tale</div>
    </div>
  );
};

export const BabyBedroom = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.99622 10.9996C8.2048 6.6336 15.7951 6.6336 21.0037 10.9996"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="12"
          cy="3.49647"
          r="1.50063"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 7.72621V4.99707"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.1634 13.3457C11.6254 12.8837 12.3744 12.8837 12.8364 13.3457L13.9046 14.4138C14.3665 14.8758 14.3665 15.6249 13.9046 16.0868L12.8364 17.155C12.3744 17.617 11.6254 17.617 11.1634 17.155L10.0952 16.0868C9.63321 15.6249 9.63321 14.8758 10.0952 14.4138L11.1634 13.3457Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.99703 13.0004V17.002"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.7794 20.1794C5.57199 20.387 5.29054 20.5036 4.99708 20.5035V20.5035C4.70362 20.5036 4.42217 20.387 4.21475 20.1794L2.8892 18.8538C2.35796 18.3084 2.36371 17.4373 2.90209 16.8989C3.44048 16.3605 4.31158 16.3548 4.85702 16.886L4.99708 17.0261L5.13714 16.886C5.68257 16.3548 6.55368 16.3605 7.09207 16.8989C7.63045 17.4373 7.63619 18.3084 7.10496 18.8538L5.7794 20.1794Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.0029 13.0004V16.0016"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="19.0029"
          cy="18.2526"
          r="2.25094"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 10.5864V13.0004"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Baby bedroom</div>
    </div>
  );
};
